import { render, staticRenderFns } from "./SelectItemSection.vue?vue&type=template&id=10a7b841"
import script from "./SelectItemSection.vue?vue&type=script&lang=js"
export * from "./SelectItemSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports